type Props = {
  title: string;
  description?: string;
  icon?: React.ReactNode;
  onClick: () => void;
};

export const InputMethodButton: React.FC<Props> = ({
  title,
  description,
  icon,
  onClick,
}) => {
  return (
    <button
      type="button"
      onClick={onClick}
      className="flex gap-16 items-center px-12 py-16 bg-white border border-solid border-line rounded-12 cursor-pointer"
    >
      {icon}
      <div className="flex flex-col items-start">
        <p className="text-md font-bold leading text-black">{title}</p>
        {description && (
          <p className="text-base text-left font-normal leading text-black-1">
            {description}
          </p>
        )}
      </div>
    </button>
  );
};
